import React, { type FC, type PropsWithChildren } from "react";
import { LegalLinkFooter } from "./LegalLinkFooter";

interface LayoutProps extends PropsWithChildren {
  hideFooter?: boolean;
  justifyContent?: 'center' | 'start';
}

export const Layout: FC<LayoutProps> = ({ children, hideFooter = false, justifyContent = 'center' }) => {
  const justifyClass = justifyContent === 'start' ? 'justify-start' : 'justify-center'
  
  return (
    <div
      data-testid="layout"
      className={`relative flex h-dvh w-full flex-1 flex-col items-center ${justifyClass} xs:gap-24 overflow-auto bg-background-contrast dark:bg-background-default-dark`}
    >
      {children}
      {!hideFooter && (
        /* biome-ignore lint/a11y/useSemanticElements: the semantic role is useless but the audit company expects to see it  */
        <footer role="contentinfo" className="w-full p-8">
          <div className="mx-auto">
            <LegalLinkFooter />
          </div>
        </footer>
      )}
    </div>
  );
};
